export const MapTheme: {
  [key: string]: any;
} = {
  // dark: 'amap://styles/2a09079c3daac9420ee53b67307a8006?isPublic=true',
  dark: 'amap://styles/dark',
  // light: 'amap://styles/1fd9f8ef9751298f11f5c56968312c70?isPublic=true',
  light: 'amap://styles/light',
  normal: 'amap://styles/normal',
  // blank: 'amap://styles/07c17002b38775b32a7a76c66cf90e99?isPublic=true',
  blank: 'amap://styles/1a91e7ec761981d85b35f3099ff781a3',
};
